import React, { useEffect, useState } from "react";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";
import { Box, Button, Card, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export default function CollapsableSection(props) {
  const {
    label,
    id,
    readOnly,
    required,
    onChange,
    //onSaveDraft = () => {},
    value,
    setIsScrollingEnabled,
    dependentElements,
    itemIndex,
    level,
    messageTime,
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
    formValues,
    children,
  } = props;

  const [internalValue, setInternalValue] = useState(value);
  const [numRequiredElementsWithNoAnswer, setNumRequiredElementsWithNoAnswer] =
    useState(0);
  const [numQuestions, setNumQuestions] = useState(0);

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef("Section", itemIndex, level, messageTime),
      true
    );
  }, []);

  useEffect(() => {
    if (internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  const handleOnChange = (newValue) => {
    setInternalValue(newValue);
    onChange(id, newValue);
  };

  useEffect(() => {
    setNumRequiredElementsWithNoAnswer(
      dependentElements.filter(
        (child) =>
          child.required &&
          formValues?.find((t) => t.id === child.id)?.value === undefined
      )?.length ?? 0
    );
    setNumQuestions(dependentElements?.length ?? 0);
  }, [dependentElements, formValues]);

  if (!dependentElements || dependentElements.length === 0) {
    console.log("No Children Found");
    return false;
  }

  return (
    <Box sx={{ flex: 1, marginBottom: 2 }} id={id}>
      <Card
        sx={{
          borderWidth: 1,
          borderRadius: 4,
          padding: 4,
          //backgroundColor: "#1C2733",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            paddingBottom: 1,
          }}
          onClick={() => handleOnChange(!internalValue)}
        >
          <Typography>{label}</Typography>
          {!readOnly && (
            <>{internalValue ? <KeyboardArrowDown /> : <KeyboardArrowUp />}</>
          )}
          {numRequiredElementsWithNoAnswer !== 0 && !readOnly && (
            <>
              <Typography>{`${numRequiredElementsWithNoAnswer} More Required Question${
                numRequiredElementsWithNoAnswer > 1 ? "s" : ""
              }`}</Typography>
            </>
          )}
          {numRequiredElementsWithNoAnswer === 0 && !readOnly && (
            <>
              <Typography>{`${numQuestions} Question${
                numQuestions > 1 ? "s" : ""
              }`}</Typography>
            </>
          )}
        </Box>
        {children}
      </Card>
    </Box>
  );
}
